/**
 * 自定义错误类
 */

class CloudflareToolsError extends Error {
  constructor(message) {
    super(message);
    this.name = 'CloudflareToolsError';
  }
}

class APIError extends CloudflareToolsError {
  constructor(message, statusCode, response) {
    super(message);
    this.name = 'APIError';
    this.statusCode = statusCode;
    this.response = response;
  }
}

class ValidationError extends CloudflareToolsError {
  constructor(message, field) {
    super(message);
    this.name = 'ValidationError';
    this.field = field;
  }
}

class ConfigError extends CloudflareToolsError {
  constructor(message) {
    super(message);
    this.name = 'ConfigError';
  }
}

class RateLimitError extends APIError {
  constructor(message, retryAfter) {
    super(message, 429);
    this.name = 'RateLimitError';
    this.retryAfter = retryAfter;
  }
}

class AuthenticationError extends APIError {
  constructor(message) {
    super(message, 401);
    this.name = 'AuthenticationError';
  }
}

class NotFoundError extends APIError {
  constructor(resource, identifier) {
    super(`${resource} not found: ${identifier}`, 404);
    this.name = 'NotFoundError';
    this.resource = resource;
    this.identifier = identifier;
  }
}

export {
  CloudflareToolsError,
  APIError,
  ValidationError,
  ConfigError,
  RateLimitError,
  AuthenticationError,
  NotFoundError
};
